//export let API_BASE_URL = 'https://octahire-staging.shekunj.com/api/v1';
export let API_BASE_URL = process.env.REACT_APP_BASE_URL;
// export let API_BASE_URL = 'https://99e2-171-61-24-224.ngrok-free.app/api/v1';
